import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Plus, Loader2, Check } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";

export default function SideSuggestion({ activeId, day, meal, onUpdated }) {
  const [sug, setSug] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const title = meal?.title;
  const hasSide = !!meal?.side;
  const load = useCallback(async () => {
    if (!activeId || !day || !title || hasSide) return;
    setLoading(true);
    try { const { data } = await api.get(`/plan/${activeId}/side/${day}`); setSug(data); } catch { /* optional */ }
    finally { setLoading(false); }
  }, [activeId, day, title, hasSide]);

  useEffect(() => { setDismissed(false); setSug(null); load(); }, [load]);

  const add = async () => {
    try {
      const { data } = await api.post("/plan/side", { household_id: activeId, day, side: sug.side });
      toast.success(`Beauty! ${sug.side} added 🙌`);
      onUpdated?.(data);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  if (meal?.side) {
    return (
      <div className="mt-3 bg-sorted-sage/50 rounded-3xl p-3 flex items-center gap-2 text-sm font-semibold text-sorted-ink" data-testid="side-added">
        <Check size={16} strokeWidth={3} /> Side: {meal.side}
      </div>
    );
  }
  if (loading) return <div className="mt-3 h-14 rounded-3xl bg-white/60 animate-pulse" data-testid="side-loading" />;
  if (!sug?.side || dismissed) return null;

  return (
    <div className="mt-3 bg-white/80 rounded-3xl border-2 border-[#FDECEF] p-3 flex items-center gap-3" data-testid="side-suggestion">
      <div className="flex-1 min-w-0">
        <p className="font-heading font-semibold text-sorted-ink text-sm">Want to add a side? {sug.side}</p>
        <p className="text-xs text-sorted-slate" data-testid="side-why">{sug.why}</p>
      </div>
      <button onClick={add} data-testid="side-yes" className="bg-sorted-rose text-white text-xs font-bold px-3 py-2 rounded-full flex items-center gap-1"><Plus size={12} strokeWidth={3} /> Yes please</button>
      <button onClick={() => { setDismissed(true); toast("No worries ❤️"); }} data-testid="side-no" className="bg-muted text-sorted-ink text-xs font-bold px-3 py-2 rounded-full">No thanks</button>
    </div>
  );
}
